import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './features.reducers';

export const selectState = createFeatureSelector<State>('features');
export const selectConsultants = createSelector(selectState, (state: State) => state.consultants);
